import { useEffect, useState } from "react";
import { QRCodeCanvas } from "qrcode.react";
import { Button, Card, Flex, Spin, Typography } from "antd";
import { useSelector } from "react-redux";

import sockets from "../../../socket/socket";

const socket = sockets;
const { Text } = Typography;

export default function QRcodeGereateSocketOuth({
  isScannerActive,
  isDarkMode,
}) {
  const [qrVal, setQrVal] = useState(null);
  const [loading, setLoading] = useState(true);
  const [socketError, setSocketError] = useState("");
  const [retryKey, setRetryKey] = useState(0);

  const reduxDark = useSelector((state) => state.ToggleDarkModeReducer?.chekced);
  const isDark = typeof isDarkMode === "boolean" ? isDarkMode : reduxDark;

  const cardBg = isDark ? "rgba(15, 23, 42, 0.78)" : "#F3F7FF";
  const borderColor = isDark ? "rgba(148, 163, 184, 0.28)" : "#E5EAF5";
  const textColor = isDark ? "#F9FAFB" : "#111827";
  const mutedColor = isDark ? "#CBD5E1" : "#667085";

  const innerBg = isDark
    ? `
      radial-gradient(circle at top left, rgba(59, 130, 246, 0.16), transparent 34%),
      radial-gradient(circle at bottom right, rgba(124, 58, 237, 0.14), transparent 32%),
      linear-gradient(135deg, #0F172A 0%, #111827 52%, #172033 100%)
    `
    : "linear-gradient(135deg, #EEF4FF 0%, #FFFFFF 52%, #EAF1FF 100%)";

  useEffect(() => {
    let isMounted = true;
    let timeoutId = null;

    const finishWithSocketId = (id) => {
      if (!isMounted) return;

      if (id) {
        setQrVal(id);
        setSocketError("");
        setLoading(false);
        console.log(id, "socketid");
      }
    };

    const getSocketID = (id) => {
      finishWithSocketId(id);
    };

    const requestSocketId = () => {
      if (!isMounted) return;

      setLoading(true);
      setSocketError("");

      socket.emit("getMySocket");

      timeoutId = setTimeout(() => {
        if (!isMounted) return;

        if (socket.id) {
          finishWithSocketId(socket.id);
          return;
        }

        setLoading(false);
        setSocketError("Не удалось получить QR-код. Попробуйте ещё раз.");
      }, 7000);
    };

    const handleConnect = () => {
      requestSocketId();
    };

    const handleConnectError = (error) => {
      console.error("Socket connect error:", error);

      if (!isMounted) return;

      setLoading(false);
      setSocketError("Нет подключения к серверу. Попробуйте ещё раз.");
    };

    setQrVal(null);
    setLoading(true);
    setSocketError("");

    socket.off("getSocketID", getSocketID);
    socket.on("getSocketID", getSocketID);

    socket.off("connect", handleConnect);
    socket.on("connect", handleConnect);

    socket.off("connect_error", handleConnectError);
    socket.on("connect_error", handleConnectError);

    if (socket.connected) {
      requestSocketId();
    } else {
      socket.connect();
    }

    return () => {
      isMounted = false;

      if (timeoutId) {
        clearTimeout(timeoutId);
      }

      socket.off("getSocketID", getSocketID);
      socket.off("connect", handleConnect);
      socket.off("connect_error", handleConnectError);
    };
  }, [isScannerActive, retryKey]);

  return (
    <Card
      bordered={false}
      style={{
        borderRadius: 22,
        background: cardBg,
        border: `1px solid ${borderColor}`,
        boxShadow: isDark
          ? "inset 0 1px 0 rgba(255,255,255,0.05)"
          : "none",
      }}
      styles={{
        body: {
          padding: "clamp(12px, 3vw, 16px)",
        },
      }}
    >
      <Flex
        vertical
        justify="center"
        align="center"
        gap={16}
        style={{
          minHeight: 330,
          borderRadius: 20,
          border: `1px solid ${isDark ? "rgba(148, 163, 184, 0.24)" : "#E5EAF5"}`,
          background: innerBg,
          padding: "clamp(18px, 4vw, 22px)",
        }}
      >
        {qrVal ? (
          <>
            <Flex
              align="center"
              justify="center"
              style={{
                padding: "clamp(16px, 4vw, 20px)",
                borderRadius: 24,
                background: "#FFFFFF",
                boxShadow: isDark
                  ? "0 24px 60px rgba(0, 0, 0, 0.52)"
                  : "0 20px 46px rgba(15, 23, 42, 0.18)",
                border: `1px solid ${isDark ? "rgba(255,255,255,0.16)" : "#FFFFFF"}`,
              }}
            >
              <QRCodeCanvas
                value={qrVal}
                size={210}
                bgColor="#ffffff"
                fgColor="#111827"
                level="Q"
                imageSettings={{
                  width: 50,
                  height: 50,
                  excavate: true,
                }}
              />
            </Flex>

            <Flex vertical align="center" gap={4}>
              <Text
                style={{
                  fontSize: 16,
                  lineHeight: "22px",
                  fontWeight: 900,
                  color: textColor,
                  textAlign: "center",
                }}
              >
                QR-код готов
              </Text>

              <Text
                style={{
                  fontSize: 14,
                  lineHeight: "20px",
                  fontWeight: 700,
                  color: mutedColor,
                  textAlign: "center",
                }}
              >
                Отсканируйте его с другого устройства для авторизации.
              </Text>
            </Flex>
          </>
        ) : loading ? (
          <Flex vertical align="center" gap={12}>
            <Spin size="large" />

            <Text
              style={{
                fontSize: 15,
                lineHeight: "22px",
                fontWeight: 800,
                color: mutedColor,
                textAlign: "center",
              }}
            >
              Генерируем QR-код...
            </Text>
          </Flex>
        ) : (
          <Flex vertical align="center" gap={12}>
            <Text
              style={{
                fontSize: 15,
                lineHeight: "22px",
                fontWeight: 800,
                color: mutedColor,
                textAlign: "center",
              }}
            >
              {socketError || "QR-код не удалось сгенерировать."}
            </Text>

            <Button
              type="primary"
              onClick={() => setRetryKey((prev) => prev + 1)}
              style={{
                height: 44,
                paddingInline: 22,
                borderRadius: 14,
                background: "#3B79F6",
                fontSize: 15,
                fontWeight: 900,
                boxShadow: "0 12px 24px rgba(59, 121, 246, 0.24)",
              }}
            >
              Повторить
            </Button>
          </Flex>
        )}
      </Flex>
    </Card>
  );
}
